import api from "../api/axios";

export const userService = {
    getProfile: () => api.get("/user/profile"),
    updateProfile: (data) => api.put("/user/profile", data),
    changePassword: (data) => api.post("/user/change-password", data),
    getTenantUsers: () => api.get("/user/tenant-users"),
    addTenantUser: (data) => api.post("/user/tenant-user", data)
};
